export enum AuctionsFilter {
    upcomming = "upcoming",
    ongoing = "ongoing",
    completed = "completed",
}
